/* Constants that may be configured differently per-site. */
const Configconstants = {
    BASEURL: "https://engine.planwatch.world/client/",
    APIVERSION: "3.00", 
    LOGINBASEURL: "https://engine.planwatch.world/scaffolding/scaffold_login.php",
    TOKEN: "",
    ACCOUNTCREATEURL: "",
    CENDVERSION: "0.2"
}

export default Configconstants


// WEBPACK FOOTER //
// ./src/Configconstants.js